export default function description() {
    return (
        <div className="card__description-basic">
            <div className="card__description">
                <p className="card__description-title">
                    Загальна характеристика
                </p>
                <p className="card__description-text">
                    ТОР 7+ СУМО (НС 7749) — це ультраранній гібрид соняшнику нового покоління, який поєднує високу врожайність із максимальною стійкістю до вовчка та ключових хвороб. Ідеально підходить для господарств, які прагнуть отримати ранній урожай без втрати продуктивності.
                </p>
                <p className="card__description-text">
                    Завдяки технології SUMO®, гібрид забезпечує ефективний контроль бур’янів і стабільну реалізацію потенціалу навіть у складних умовах вирощування.
                </p>
                <p className="card__description-title">Основні переваги</p>
                <ol className="card__description-list">
                    <li className="card__description-numbering">Ультраранній гібрид — швидке дозрівання (90–95 днів)</li>
                    <li className="card__description-numbering">Потенціал урожайності — до 5,0 т/га</li>
                    <li className="card__description-numbering">Стійкість до вовчка — 7+ рас (A–G+)</li>
                    <li className="card__description-numbering">Стійкість до всіх рас несправжньої борошнистої роси</li>
                    <li className="card__description-numbering">Висока адаптивність і стабільність</li>
                    <li className="card__description-numbering">Відмінна енергія початкового росту</li>
                </ol>
                <table className="card__description__table">
                    <tr>
                        <td className="card__description__td">Період вегетації</td>
                        <td className="card__description__th-index">90–95 днів</td>
                    </tr>
                    <tr>
                        <td className="card__description__td">Олійність:</td>
                        <td className="card__description__th-index">50–52%</td>
                    </tr>
                    <tr>
                        <td className="card__description__td card__description__td--link">Висота рослин</td>
                        <td className="card__description__th-index">145–165 см</td>
                    </tr>
                </table>
                <p className="card__description-title">
                    Рекомендації по густоті
                </p>
                <ol className="card__description-list">
                    <li className="card__description-numbering">За достатнього зволоження: 65–70 тис. рослин/га</li>
                    <li className="card__description-numbering">У посушливих умовах: 55–60 тис. рослин/га</li>
                </ol>
                <div className="card__description-title">Стійкість та толерантність</div>
                <ol className="card__description-list">
                    <p className="card__description-text">
                        Стійкість:
                    </p>
                    <li className="card__description-numbering">Посухостійкість, осипання, вилягання — 9/10</li>
                    <li className="card__description-numbering">Холодостійкість — 8/10</li>
                    <p className="card__description-text">
                        Толерантність до хвороб:
                    </p>
                    <li className="card__description-numbering">Пероноспороз, біла та сіра гнилі, іржа, фомопсис — 9/10</li>
                    <li className="card__description-numbering">Фомоз, альтернаріоз, септоріоз, вугільна гниль — 8/10</li>
                </ol>
                <div className="card__description-title">Рекомендовані зони вирощування</div>
                <p className="card__description-text">
                    Гібрид рекомендований для вирощування по всій території України, особливо ефективний у Степу та Лісостепу, де важлива рання віддача врожаю та стійкість до стресів.
                </p>
                <div className="card__description-title">Рекомендації щодо вирощування</div>
                <p className="card__description-text">
                    ТОР 7+ СУМО ідеально підходить для інтенсивних технологій вирощування, а також для господарств, які прагнуть мінімізувати ризики через кліматичні фактори.
                </p>
                <p className="card__description-text">
                    ТОР 7+ СУМО ідеально підходить для інтенсивних технологій вирощування, а також для господарств, які прагнуть мінімізувати ризики через кліматичні фактори.
                </p>
                <p className="card__description-text">
                    ТОР 7+ СУМО — це ідеальний вибір для тих, хто хоче ультраранній урожай + максимальний захист від вовчка. Один із найкращих варіантів для зон із високим рівнем зараження вовчком та ризикованого землеробства.
                </p>
            </div>
            <div className="card__description-preference">
                <div className="aside__title--new">Головні переваги</div>
                <div className="asede__head">
                    <div className="aside__block">Високий потенція урожайності</div>
                    <div className="aside__block">Найкращу віддачу забезпечує на родючих грунтах</div>
                    <div className="aside__block">Один із найбільш високоврожайних гібридів з високим вмістом олії</div>
                </div>
            </div>
        </div>
    );
}
